import { LeaveUtilization } from 'components/employee-analytics/analytic-item/LeaveUtilization'
import { useState, useEffect, useRef } from 'react'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'
import { useFetch } from 'services/useFetch'
import moment from 'moment'

const INITIAL_FILTER = {
    year: moment().get('year'),
    company_ids: [],
    department_ids: [],
    division_ids: [],
    sub_division_ids: [],
}

const LeaveUtilizationContainer = () => {
    const { fetching: getLeaveUtilization, isLoading } = useFetch(API_EMPLOYEE_ANALYTICS.LEAVE_UTILIZATION)
    const [leaveUtilizationData, setLeaveUtilizationData] = useState([])
    const [filter, setFilter] = useState(INITIAL_FILTER)
    const [isBottom, setIsBottom] = useState(false)
    const scrollRef = useRef(null)

    const getBalancedRandomColor = () => {
        const min = 80
        const max = 200

        const r = Math.floor(Math.random() * (max - min) + min)
        const g = Math.floor(Math.random() * (max - min) + min)
        const b = Math.floor(Math.random() * (max - min) + min)

        return `rgb(${r}, ${g}, ${b})`
    }

    useEffect(() => {
        ;(async () => {
            const leaveUtilization = await getLeaveUtilization(filter)
            const newData = leaveUtilization?.data?.map((item) => ({
                ...item,
                color: getBalancedRandomColor(),
            }))

            setLeaveUtilizationData(newData)
        })()
    }, [filter])

    const handleScroll = () => {
        const el = scrollRef.current
        if (!el) return

        const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1

        setIsBottom(isAtBottom)
    }

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
        }
    }

    const props = {
        data: leaveUtilizationData,
        isLoading,
        isBottom,
        scrollRef,
        handleScroll,
        filter,
        onSubmitFilter,
    }

    return <LeaveUtilization {...props} />
}

export default LeaveUtilizationContainer
